export default class Collapsible {
  constructor(selector = '.collapsible') {
    this.activeClass = 'collapsible-active';
    this.selector = selector;
    this.$el = $(selector);

    this.init();
  }

  bindCollapseButtons() {
    const that = this;
    $('body').on('click', '.collapsible-button', function() {
      $(this).parents(that.selector).toggleClass(that.activeClass);
      $(this).find('.icon').toggleClass('hidden');
    });
  }

  destroy() {
    $('body').off('click', '.collapsible-button');
  }

  init() {
    this.bindCollapseButtons();
  }
}
/*scrolling to product page*/
$(document).ready(function(){
	$('.row .ingredient').each(function(index) {
	  var setId = $('.ingredient').eq(index).find('.ingredient__title').text().replace(/ /g, "").toLowerCase();
	   $(this).attr('id', setId); 
	});

	$('.footer-mainnav .collapsible ul li').on('click', function(e) {
		var headerHgt = $('header nav').outerHeight(),
		selectedElem = $(this).find('a').text();
		selectedElem = selectedElem.replace(/ /g, "").toLowerCase();
	   $('html, body').animate({scrollTop: $('#' + selectedElem).offset().top - headerHgt});
	});
	setTimeout(function () {	
		var hasTag = window.location.hash.replace('#','');
			hasTag = decodeURIComponent(hasTag);
		var titleTxt = "";	
		if(hasTag){
			$('h2.ingredient__title').each(function(){
				titleTxt = $(this).text();
				if(titleTxt == hasTag){
					var headElementHeight = $('header nav').outerHeight();
					var scrollToVal = $(this).offset().top - headElementHeight;
					window.scrollTo(0, scrollToVal);				
				}
			});
		}
	}, 1000 );
});

jQuery(function(){
	/*Data privacy page script*/
	$('.privacy-hier').click(function() {
	   var headerHgt = $('header nav').outerHeight();
	   var index = $('.privacy-hier').index(this);
	   $('html, body').animate({
		 scrollTop: $($('.privacy-hier-details')[index]).offset().top - headerHgt
	   }, 1000);
	});
	/*faq navigation*/
	$('.faq-questions a').click(function() {
	   var headerHgt = $('header nav').outerHeight();	   
	   var index = $('.faq-questions a').index(this);
	   $('html, body').animate({
		 scrollTop: $($('.faq-section')[index]).offset().top - headerHgt
	   }, 500);
	});
	/*owl-carousel-arrow-script*/
	$(".latest-articles .owl-carousel .owl-nav button.owl-prev, .latest-articles .owl-carousel .owl-nav button.owl-next").bind("touchstart mousedown mouseover", function (e) {
		$(this).css('background-color','#046ec4');
		$(this).find('.icon').css('fill','#fff');
	});
	setTimeout(function () {	
		$(".latest-articles .owl-carousel .owl-nav button.owl-prev, .latest-articles .owl-carousel .owl-nav button.owl-next").bind("touchend mouseup mouseleave", function (e) {
			$(this).css('background-color','#fff');
			$(this).find('.icon').css('fill','#046ec4');
		});
	}, 500 );
	
	/* unsere historie page script*/
	if (jQuery(window).width() >= 992) {
		var divs = $("div.text-part, div.image-part");
		jQuery('.brand-history-wrapper .content-block').find('.text-part').closest('.col-md-6').removeClass('col-md-6 col-md-push-5').addClass('col-md-10 col-md-push-1 col-md-pull-1');
		for(var i=0; i<divs.length;) {
		 i += divs.eq(i).nextUntil(':not(.text-part, .image-part)').addBack().wrapAll('<div class="content-outer" />').length;
		}
		$('.image-part:parent').each( function(index) {
		   if (index%2 == 0) {
			$('.text-part').css('padding', '0 40px 0 40px');
		   }
		   else {
			$(this).insertBefore($(this).prev('.text-part'));
			$('.text-part').css('padding', '0 56px 0 25px');
		   }
		});
	}
	
	/*Home page slider*/
	
	if (jQuery(window).width() >= 768){
	$(".Homepage-carousel .carousel-control-mobile .next-button, .Homepage-carousel .carousel-control-mobile .prev-button").bind("touchstart mousedown mouseover", function (e) {
		$(this).css('background-color','#046ec4');
		$(this).find('.icon').css('fill','#fff');
	});
	setTimeout(function () {	
		$(".Homepage-carousel .carousel-control-mobile .next-button, .Homepage-carousel .carousel-control-mobile .prev-button").bind("touchend mouseup mouseleave", function (e) {
			$(this).css('background-color','#fff');
			$(this).find('.icon').css('fill','#046ec4');
		});
	}, 500 );
	}
	
});
/*setting cookie for kenya page*/
function setCookie(cookiename, cookievalue) {
  document.cookie = cookiename + '=' + cookievalue + ';' + ';path=/' + ';SameSite=Lax';
}
function getCookie(cookiename) {
  const name = cookiename + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookievalue = decodedCookie.split(';');
  for (let i = 0; i < cookievalue.length; i++) {
    let storecookie = cookievalue[i];
    while (storecookie.charAt(0) == ' ') {
      storecookie = storecookie.substring(1);
    }
    if (storecookie.indexOf(name) == 0) {
      return storecookie.substring(name.length, storecookie.length);
    }
  }
  return '';
}
function checkCookie() {
  if (window.location.href.indexOf('kenya') > -1)
			{
    setCookie('kenya', 1);
  }

  const usercookie = getCookie('kenya');
  if (usercookie == '') {
    var logoclick = document.querySelectorAll('.mixa-logo');
    for (var i = 0; i < logoclick.length; i++) {
      logoclick[i].addEventListener('click', () => {
        window.location.href = '/';
      });
    }
  }
  else {
    var logoclick = document.querySelectorAll('.mixa-logo');
    for (var i = 0; i < logoclick.length; i++) {
      logoclick[i].addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = '/kenya';
      });
    }
  }
}
window.onload = checkCookie;
window.onbeforeunload = CloseSession;
function CloseSession() {
  if (((window.event.clientY < 0) && (window.event.clientX > 40))|| (event.altKey == true && event.keyCode == 0))
  {   
    setCookie('kenya', '', 0);
  }
}
